import Error404Screen from './containers/error404Screen'

export {default as Error404ScreenLayout} from './components/error404ScreenLayout'

export default Error404Screen
